export default {
  "b2b.notifikace.title": "Notifikace",
  "b2b.notifikace.empty": "Nemáte žádné notifikace",
  "b2b.notifikace.read-all": "Přečíst vše",
  "b2b.notifikace.delete-all": "Smazat vše",
  "b2b.notifikace.success-read":
    "{length, plural, one {Notifikace byla přečtena} other {Notifikace byly přečteny}}",
  "b2b.notifikace.success-delete":
    "{length, plural, one {Notifikace byla smazána} other {Notifikace byly smazány}}"
};
